import gsap from 'gsap';
import SplitText from '@/assets/lib/gsap/uncompressed/utils/SplitText';

import { revertSplit, isMobile } from '@/scripts/utils';


const lerp = (a, b, n) => ((1 - n) * a) + (n * b);
const transitions = new Map();

transitions.set('pageTransition', (el, dir, callback) => {
  const val = dir === 'in' ? { pos: 0, op: 1 } : { pos: 1, op: 0 };
  const cover = document.querySelector('.transition-cover');

  const tl = new gsap.TimelineMax({
    onUpdate: () => {
      cover.style.background = `radial-gradient(ellipse at center, rgba(0,0,0,0) 0%, rgba(0,0,0,${val.op}) ${val.pos}%)`;
    },
    onComplete: callback,
  });

  tl.add('start')
    .set(el, { autoAlpha: 1 }, 'start')
    .to(val, 1, {
      pos: dir === 'in' ? '+=100' : '-=100',
    }, 'start')
    .to(val, 1, {
      op: dir === 'in' ? '-=1' : '+=1',
    }, '-=0.5');
});

transitions.set('loaderTransitionIn', (el, callback) => {
  if (isMobile()) {
    gsap.fromTo(el, 0.3, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      onComplete: callback,
    });
  } else {
    const $text = el.querySelector('[data-text]');
    const split = new SplitText($text, { type: 'lines, words', linesClass: 'loaderSplit' });

    let dir = 0;

    const tl = new gsap.TimelineMax({
      onComplete: callback,
    });

    // tl
    //   .fromTo(el, 0.2, { autoAlpha: 0 }, { autoAlpha: 1 })
    //   .add('start')
    //   .staggerFromTo(this.split, 1.8, {
    //     y: 20,
    //     autoAlpha: 0,
    //   }, {
    //     y: 0,
    //     autoAlpha: 1,
    //     onStartParams: ['{self}'],
    //     onStart: (self) => {
    //       const chars = new SplitText(self.target, { type: 'words, chars' }).chars;

    //       dir += 1;
    //       const yo = -(Math.cos((dir % 2) * Math.PI));

    //       gsap.staggerFromTo(chars, 1, {
    //         autoAlpha: 0,
    //       }, {
    //         autoAlpha: 1,
    //         ease: gsap.Expo.easeOut,
    //       }, 0.03 * yo);
    //     },
    //   }, 0.4);

    tl
      .fromTo(el, 0.2, { autoAlpha: 0 }, { autoAlpha: 1 })
      .add('start')
      .staggerFromTo('.loaderSplit', 1, {
        y: 50,
        skewX: -10,
        rotation: 5,
        autoAlpha: 0,
      }, {
        y: 0,
        skewX: 0,
        rotation: 0,
        autoAlpha: 1,
        clearProps: 'all',
        delay: 0.2,
      }, 0.1);
  }
});

transitions.set('loaderTransitionOut', (el, callback) => {
  // let split = [];
  // if (isMobile()) {
  //   const $text = el.querySelector('[data-text]');
  //   split = new SplitText($text, { type: 'lines, words', linesClass: 'loaderSplit' });
  // } else {
  //   split = Array.from(el.querySelectorAll('.loaderSplit'));
  // }
  // let dir = 0;

  // const tl = new gsap.TimelineMax({
  //   onComplete: callback,
  // });

  gsap.to(el, 0.5, {
    autoAlpha: 0,
    onComplete: callback,
  });

  // tl
    // .add('start')
    // .staggerFromTo(split, 1.2, {
    //   y: 0,
    //   autoAlpha: 1,
    // }, {
    //   y: -20,
    //   autoAlpha: 0,
    //   onStartParams: ['{self}'],
    //   onStart: (self) => {
    //     const chars = new SplitText(self.target, { type: 'words, chars' }).chars;

    //     dir += 1;
    //     const yo = Math.cos((dir % 2) * Math.PI);

    //     gsap.staggerFromTo(chars, 0.4, {
    //       autoAlpha: 1,
    //     }, {
    //       autoAlpha: 0,
    //     }, 0.02 * yo);
    //   },
    // }, 0.2);

    // .add('start')
    // .staggerFromTo('.loaderSplit', 1, {
    //   y: 0,
    //   skewX: 0,
    //   rotation: 0,
    //   autoAlpha: 1,
    // }, {
    //   y: -50,
    //   skewX: 10,
    //   rotation: -5,
    //   autoAlpha: 0,
    // }, 0.1);
});

export default transitions;



// WEBPACK FOOTER //
// ./src/scripts/transitions.js